/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoOdnoklassnikiViaVkontakteLoginOptions } from './FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoOdnoklassnikiViaVkontakteLoginOptions';
import {
    instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoOdnoklassnikiViaVkontakteLoginOptions,
    FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoOdnoklassnikiViaVkontakteLoginOptionsFromJSON,
    FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoOdnoklassnikiViaVkontakteLoginOptionsFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoOdnoklassnikiViaVkontakteLoginOptionsToJSON,
} from './FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoOdnoklassnikiViaVkontakteLoginOptions';

/**
 * @type FxIdWebFeaturesAuthAuthenticateFromSocialRequestOdnoklassnikiViaVkontakteLogin
 *
 * @export
 */
export type FxIdWebFeaturesAuthAuthenticateFromSocialRequestOdnoklassnikiViaVkontakteLogin = FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoOdnoklassnikiViaVkontakteLoginOptions;

export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestOdnoklassnikiViaVkontakteLoginFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateFromSocialRequestOdnoklassnikiViaVkontakteLogin {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestOdnoklassnikiViaVkontakteLoginFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestOdnoklassnikiViaVkontakteLoginFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateFromSocialRequestOdnoklassnikiViaVkontakteLogin {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoOdnoklassnikiViaVkontakteLoginOptions(json)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoOdnoklassnikiViaVkontakteLoginOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestOdnoklassnikiViaVkontakteLoginToJSON(json: any): any {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestOdnoklassnikiViaVkontakteLoginToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestOdnoklassnikiViaVkontakteLoginToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateFromSocialRequestOdnoklassnikiViaVkontakteLogin | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoOdnoklassnikiViaVkontakteLoginOptions(value)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoOdnoklassnikiViaVkontakteLoginOptionsToJSON(value as FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoOdnoklassnikiViaVkontakteLoginOptions);
    }

    return {};
}
